import { Serializable } from '@/models/core/serializable';

export class EventForList implements Serializable<EventForList> {
	ID: number;
	eventName: string;
	eventStartDate: Date = new Date();
	eventEndDate: Date = new Date();
	beforeSurveyStartDate: Date = new Date();
	beforeSurveyEndDate: Date = new Date();
	afterSurveyStartDate: Date = new Date();
	afterSurveyEndDate: Date = new Date();
	existBeforeGiftCourse: boolean = false;
	existAfterGiftCourse: boolean = false;

  deserialize(input: any): EventForList {
    this.ID = input.ID;
    this.eventName = input.eventName;
    this.eventStartDate = new Date(input.eventStartDate);
    this.eventEndDate = new Date(input.eventEndDate);
    this.beforeSurveyStartDate = new Date(input.beforeSurveyStartDate);
    this.beforeSurveyEndDate = new Date(input.beforeSurveyEndDate);
    this.afterSurveyStartDate = new Date(input.afterSurveyStartDate);
    this.afterSurveyEndDate = new Date(input.afterSurveyEndDate);
    this.existBeforeGiftCourse = input.existBeforeGiftCourse;
    this.existAfterGiftCourse = input.existAfterGiftCourse;

    return this;
  }
}